

























































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { ListingDetail } from '@/models/ListingDetail';
import HRMDataInfo from '@/components/HRMDataInfo.vue';
import GoogleMapPanel from '@/components/GoogleMapPanel.vue';
import TaxesPanel from '@/components/TaxesPanel.vue';
import DemographicsPanel from '@/components/DemographicsPanel.vue';
import SalesHistoryPanel from '@/components/SalesHistoryPanel.vue';
import PhotoPanel from '@/components/PhotoPanel.vue';
import Defs from '../utils/Defs';
import ListingUtil from '../utils/ListingUtil';

@Component({
    components: {
        HRMDataInfo,
        GoogleMapPanel,
        TaxesPanel,
        DemographicsPanel,
        SalesHistoryPanel,
        PhotoPanel,
    },
})
export default class ListingDetailsDialog extends Vue {

    public widthThresholdValue: number = 768;
    public heightThresholdValue: number = 415;

    public columns = [
        { name: 'Level', align: 'left', label: 'Level', field: 'level', style: 'width: 130px;'},
        { name: 'Type', align: 'left', label: 'Type', field: 'type', style: 'width: 130px' },
        { name: 'Dimensions', align: 'left', label: 'Dimensions', field: 'dimensions' },
    ];

    public showDialog: boolean = false;
    public tab: string = 'overview';

    public unsubscribe = this.$store.subscribeAction((action, state) => {
        if (action.type === 'showListingDialog') {
            this.onShowDialog();
        }
        if (action.type === 'showListingDialogPhotos') {
            this.onShowDialogPhotos();
        }
    });

    public onTabChange(tab: string) {
        // analytics events
        if (tab === 'taxes') {
            this.$store.dispatch('sendDetailsEvent', {action: Defs.ANALYTICS_DETAILS_TAX, sysId: this.selectedListingDetail.SystemId});
        }
        if (tab === 'photos') {
            this.$store.dispatch('sendDetailsEvent', {action: Defs.ANALYTICS_DETAILS_PHOTOS, sysId: this.selectedListingDetail.SystemId});
        }
        if (tab === 'streetView') {
            this.$store.dispatch('sendDetailsEvent', {action: Defs.ANALYTICS_DETAILS_STREETVIEW, sysId: this.selectedListingDetail.SystemId});
        }
        if (tab === 'hrmData') {
            this.$store.dispatch('sendDetailsEvent', {action: Defs.ANALYTICS_DETAILS_HRM, sysId: this.selectedListingDetail.SystemId});
        }
        if (tab === 'salesHistory') {
            this.$store.dispatch('sendDetailsEvent', {action: Defs.ANALYTICS_DETAILS_HISTORY, sysId: this.selectedListingDetail.SystemId});
        }
        if (tab === 'schools') {
            this.$store.dispatch('sendDetailsEvent', {action: Defs.ANALYTICS_DETAILS_SCHOOLS, sysId: this.selectedListingDetail.SystemId});
        }
        if (tab === 'demographics') {
            this.$store.dispatch('sendDetailsEvent', {action: Defs.ANALYTICS_DETAILS_DEMO, sysId: this.selectedListingDetail.SystemId});
        }
    }

    public onOpenBookViewingDialog() {
        this.$store.dispatch('showBookViewingDialog');
    }

    public onOpenShareDialog() {
        this.$store.dispatch('showShareDialog', 'LISTING');
    }

    public mounted() {
        window.onresize = this.setWrapperHeight;
    }

    get config() {
        return this.$store.state.config;
    }

    get map() {
        return this.$store.state.map;
    }

    get windowWidth() {
        return this.$store.state.windowWidth;
    }

    get isMobile(): boolean {
        return (this.$q.screen.width <= this.widthThresholdValue) || (this.$q.screen.height <= this.heightThresholdValue);
    }

    get selectedListingDetail(): ListingDetail {
        if (this.$store.state.listings.selectedListingDetail && this.$store.state.listings.selectedListingDetail.SystemId && this.showDialog) {
            this.$store.dispatch('sendListingEvent', {action: Defs.ANALYTICS_LISTING_VIEWDETAILS, sysId: this.$store.state.listings.selectedListingDetail.SystemId});
        }
        return this.$store.state.listings.selectedListingDetail;
    }

    get address() {
        if (this.selectedListingDetail) {
            return this.selectedListingDetail.Address;
        }
    }

    get roomsData(): string[] {
        if (this.$store.state.listings.selectedListingDetail.Rooms) {
            return this.$store.state.listings.selectedListingDetail.Rooms;
        }
        return []; // table does not get inialized properly if data is null
    }

    get isBuildingsSpecsVisible(): boolean {
        return (this.selectedListingDetail.Foundation !== '---' || this.selectedListingDetail.Roof !== '---' ||
                this.selectedListingDetail.ExternalFinish !== '---' || this.selectedListingDetail.Flooring !== '---');
    }

    get selectedListingStatusClass(): string {
        const status = this.selectedListingDetail.ListStatus;
        if (status === null || status === undefined) {
            return 'listingStatusType_NOSTATUS';
        }

        if (status === 'FOR SALE') {
            return 'listingStatusType_FORSALE';
        } else if (status === 'SOLD') {
            return 'listingStatusType_SOLD';
        } else if (status === 'PENDING') {
            return 'listingStatusType_PENDING';
        } else {
            return 'listingStatusType_NOSTATUS';
        }
    }

    get formattedPrice(): string {
        const listPrice = this.selectedListingDetail.ListPrice;
        return ListingUtil.getFormatedPrice(listPrice);
    }

    get formattedParcelSize(): string {
        const parcelSize = Number(this.selectedListingDetail.ParcelData?.ParcelSizeFtSq);
        return ListingUtil.getParcelSizeAcres(parcelSize);
    }

    get isContainsHRMData(): boolean {
        const parcelHrmData = this.selectedListingDetail.ParcelData?.ParcelHrmData;
        const HRMParcelItems = [parcelHrmData?.PID, parcelHrmData?.ByLawId, parcelHrmData?.WasteCollectArea, parcelHrmData?.WasteCollectContractor,
                                parcelHrmData?.ByLawCode, parcelHrmData?.ByLawName, parcelHrmData?.ZoneByLawId,
                                parcelHrmData?.PollDistId, parcelHrmData?.PollDistName, parcelHrmData?.Councillor, parcelHrmData?.WasteCollect];
        return HRMParcelItems.some((item) => item !== undefined);
    }

    public addSpaceAfterCommas(details: string) {
        return details.replace(/,[s]*/g, ', ');
    }

    public onShowDialog() {
        this.showDialog = true;
        this.tab = 'overview';
        this.setWrapperHeight();
    }

    public setWrapperHeight() {
        if (this.isMobile) {
            const height = window.innerHeight - 110;
            this.$nextTick(function() {
                // @ts-ignore
                this.$refs.detailWrapper.$el.style.height = height + 'px';
            });
        }
    }

    public onShowDialogPhotos() {
        this.showDialog = true;
        this.tab = 'photos';
    }
}

